//https://api.slack.com/reference/block-kit/composition-objects#text
export const MAXIMUM_SLACK_TEXT_FIELD = 3000;
export const MAXIMUM_FORM_TITLE = 46;
export const MAXIMUM_QUESTION_LABEL = 255;
export const MAXIMUM_QUESTION_HINT = 255;
